import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface FolderLockIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const FolderLockIcon = ({ className, ...props }: FolderLockIconProps) => (
  <svg
    className={cn("text-[#6C8FD4]", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.4 20H2.6C2.26863 20 2 19.7314 2 19.4V11V4.6C2 4.26863 2.26863 4 2.6 4H8.77805C8.92127 4 9.05977 4.05124 9.16852 4.14445L12.3315 6.85555C12.4402 6.94876 12.5787 7 12.722 7H21.4C21.7314 7 22 7.26863 22 7.6V11V19.4C22 19.7314 21.7314 20 21.4 20Z"
      fill="currentColor"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M12 9C12.9269 9 13.5698 9.42478 13.9521 9.98242C14.3071 10.5002 14.417 11.0956 14.417 11.5V12.6025C14.9059 12.8054 15.2498 13.2873 15.25 13.8496V16.1504C15.2498 16.8957 14.6457 17.4998 13.9004 17.5H10.0996C9.35433 17.4998 8.75021 16.8957 8.75 16.1504V13.8496C8.75016 13.2873 9.09407 12.8054 9.58301 12.6025V11.5C9.58301 11.0956 9.69294 10.5002 10.0479 9.98242C10.4302 9.42478 11.0731 9 12 9ZM11.5 13.75V15.75H12.5V13.75H11.5ZM12 10.5C11.5937 10.5 11.4028 10.6586 11.2852 10.8301C11.1403 11.0414 11.083 11.3212 11.083 11.5V12.5H12.917V11.5C12.917 11.3212 12.8597 11.0414 12.7148 10.8301C12.5972 10.6586 12.4063 10.5 12 10.5Z"
      fill="white"
    />
  </svg>
);

export default FolderLockIcon;
